module.exports = __webpack_public_path__ + "assets/img/gift-3-0068f53f.png";